const messageFromText = (text, fallbackMessage) => {
  try {
    const payload = JSON.parse(text);
    return typeof payload.message === "string" && payload.message
      ? payload.message
      : fallbackMessage;
  } catch (error) {
    return fallbackMessage;
  }
};

const readBlobAsText = (blob) => {
  if (typeof blob.text === "function") {
    return blob.text();
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
};

export const getApiErrorMessage = async (response, fallbackMessage) => {
  const data = response && response.data;

  if (data && typeof data.message === "string" && data.message) {
    return data.message;
  }
  if (typeof data === "string") {
    return messageFromText(data, fallbackMessage);
  }
  if (typeof Blob !== "undefined" && data instanceof Blob) {
    try {
      return messageFromText(await readBlobAsText(data), fallbackMessage);
    } catch (error) {
      return fallbackMessage;
    }
  }
  return fallbackMessage;
};
